export const TABS_LOCALE_ZHCHT = {
    more: 'æ´å¤',
};
